import React from 'react';

export default {
    TradChn : {
        formTitle: "「綜合註冊資訊系統」網上服務 - 查詢表格", 
        steps_Particulars: "客戶資料",

        PICSContent: ()=>      [<> 
            <p>1. <span style={{textDecoration:"underline"}}>收集目的</span></p>
            <p>
            土地註冊處將會把本表格所收集的個人資料用於以下目的:-
                <ol style={{listStyleType: "lower-latin"}}>
                    <li>處理與提供土地註冊處服務有關的事宜；</li>
                    <li>方便進行聯絡；以及</li>
                    <li>製備與土地註冊處服務有關的統計資料。</li>
                </ol>
            </p>
            <p>
                你明白提供個人資料與否純屬自願。倘若你不提供本表格所要求的資料，本處可能無法提供所要求的服務。
            </p>
            <p>
                <span style={{fontWeight:"bold"}}>請勿</span>提供任何沒有明確規定必須提交的個人資料(包括關乎第三者的個人資料)。如本表格或所提交的任何與其有關的文件中包含任何第三者的資料，本處將視作你已獲該第三者同意披露該等資料，以用於上述目的。
            </p>
            
            <p>2. <span style={{textDecoration:"underline"}}>個人資料的披露</span></p>
            <p>
                你明白為達到上文第一段中所述明目的而有需要時，你在本表格內所提供的個人資料可能會披露或轉交予相關人士。
            </p>    
            <p>3. <span style={{textDecoration:"underline"}}>查閱個人資料</span></p>
            <p>
                你明白根據《個人資料(私隱)條例》(第486章) 第18和第22條，以及附表1第6原則，你有權要求查閱及更正本處所持有你的個人資料。根據該條例，本處有權就處理該等要求收取費用。任何該等要求可向本處的個人資料(私隱)主任提出(地址：香港金鐘道66號金鐘道政府合署28樓土地註冊處)。
            </p>
        </>]
        ,
 
        // Form fields
        part_1_Particulars:         "I 客戶資料", 
        part_2_OrderDetails:        "II 訂單詳情", 
        part_3_Issues:              "III 查詢事項", 
        part_4_SignatoryDetails:    "IV 簽署人資料",         
        
        // Form - Part1
        OlsAccName:     "登記用戶賬戶名稱/客戶姓名", 
        OlsAccNo:       "登記用戶賬戶號碼", 
        ContactPerson:  "聯絡人姓名", 
        ContactPhone:   "聯絡電話號碼", 
        ContactEmail:   "電郵地址", 

        // Form - Part2
        TransOrder:         "交易參考類別", 
        field_transOrder_list:[
            {id: "TransOrder", value: "NaN_Trans_Opt_1", text: "付款交易編號"},
            {id: "TransOrder", value: "NaN_Trans_Opt_2", text: "訂單編號" },
        ],
        TransactionNo:      "付款交易編號", 
        OrderNo:            "訂單編號", 
        DateOfOrder:        "訂單日期", 
        TimeOfOrder:        "訂單時間", 
        OrderType:          "訂單類別", 
        OrderType_Other:    "訂單類別 - 其他",
        field_orderType_list:[
            {id: "OrderType", value: "NaN_OrderType_Opt_1", text: "土地登記冊"},
            {id: "OrderType", value: "NaN_OrderType_Opt_2", text: "土地文件"},
            {id: "OrderType", value: "NaN_OrderType_Opt_3", text: "尚未記入土地登記冊的註冊摘要資料"},
            {id: "OrderType", value: "NaN_OrderType_Opt_4", text: "其他"},
        ],
        field_refType_list:[
            {id: "RefType", value: "NaN_RefType_Opt_1", text: "物業地址"},
            {id: "RefType", value: "NaN_RefType_Opt_2", text: "地段編號"},
            {id: "RefType", value: "NaN_RefType_Opt_3", text: "物業參考編號"},
            {id: "RefType", value: "NaN_RefType_Opt_4", text: "註冊摘要編號"},
        ],

        // Form - Matter
        Problems1:          "如何查閱土地登記冊", 

        Problems2:          "澄清土地登記冊上的資料", 
        LandRegisterAttach: "登記冊副本", 

        Problems3:          "影像問題", 
        ImageProblem:       "影像問題類別", 
        field_imageProblem_list:[
            {id: "ImageProblem", value: "NaN_Image_Opt_1", text: "不清晰"},
            {id: "ImageProblem", value: "NaN_Image_Opt_2", text: "不完整"},
            {id: "ImageProblem", value: "NaN_Image_Opt_3", text: "空白頁"},            
        ],
        ImageAttach:        "有問題各頁的副本", 

        Problems4:          "錯誤文件", 
        WrongDocAttach:     "首兩頁的副本", 

        Problems5:          "未能收取已訂購的土地紀錄並要求將土地紀錄重發至", 
        RequestFor:         "電郵地址 / 傳真號碼", 

        Problems6:          "其他", 
        Others:             "詳情", 

        // Form - Part3
        NameEN:             "簽署者姓名", 
    }
}